import apiHandler from "./apiHandler";

const apiExpenses = {
  airline: (airline, start, end) => {
    return new Promise((resolve, reject) => {
      apiHandler
        .post(`/airline/${airline._id}/expenses`, {
          start,
          end,
        })
        .then((response) => {
          resolve(response.data.results);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  airport: (airline, icao, start, end) => {
    return new Promise((resolve, reject) => {
      apiHandler
        .post(`/airline/${airline}/expenses/airport/${icao}`, {
          start,
          end,
        })
        .then((response) => {
          resolve(response.data.results);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  schedule: (airline, id, start, end) => {
    return new Promise((resolve, reject) => {
      apiHandler
        .post(`/airline/${airline}/expenses/schedule/${id}`, {
          start,
          end,
        })
        .then((response) => {
          resolve(response.data.results);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  pilot: (airline, id, start, end) => {
    return new Promise((resolve, reject) => {
      apiHandler
        .post(`/airline/${airline}/expenses/pilot/${id}`, {
          start,
          end,
        })
        .then((response) => {
          resolve(response.data.results);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  aircraft: (airline, id, start, end) => {
    return new Promise((resolve, reject) => {
      apiHandler
        .post(`/airline/${airline}/expenses/aircraft/${id}`, {
          start,
          end,
        })
        .then((response) => {
          resolve(response.data.results);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

export default apiExpenses;
